import React, { useState }  from "react";
import { Button } from "semantic-ui-react";
import ICON from 'components/cmp_icon/cmp_icon'

import CPM_CONTACT_UPDATE from '../cmp_contact_udpate/cmp_contact_update'
import CPM_CONTACT_DELETE from '../cmp_contact_delete/cmp_contact_delete'

import './cmp_contact_read.css';



export default function CMP_CONTACT_READ({ contact, onRefresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_contact_update_open, set_contact_update_open ] = useState(false);
    const [ var_contact_delete_open, set_contact_delete_open ] = useState(false);



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_update(){
        set_contact_update_open(true);
    }

    function onClick_delete(){
        set_contact_delete_open(true);
    }



    // RENDER CONTAINER ================================================================================================

    return (

        <div className='card detail'>
            <div className='card__header'>
                <div className='icon__wrapper'>
                    <div className='icon'>
                        <ICON name='profile_female_1' className='icon' alt='contact icon'/>
                    </div>
                </div>
            </div>

            <div className='card__content'>
                <div className='primary_contact text--md bold'>{contact.contact_type}</div>

                <div className='contact__wrapper'>
                    <ICON name='email' className='icon' alt='email icon'/>
                    <div>{contact.email}</div>
                </div>

                <div className='contact__wrapper'>
                    <ICON name='phone' className='icon' alt='phone icon'/>
                    <div>{contact.phone}</div>
                </div>

                <div className='contact__wrapper'>
                    <ICON name='profile_female_1' className='icon' alt='contact icon'/>
                    <div>{contact.name}</div>
                </div>
            </div>

            <div className='card__footer'>
                <Button className='icon' onClick={onClick_update}><ICON name='pencil' className='icon' alt='edit icon'/></Button>
                <Button className='icon' onClick={onClick_delete}><ICON name='delete' className='icon' alt='delete icon'/></Button>
            </div>

            <CPM_CONTACT_UPDATE
                id={contact.id}
                onOpen={var_contact_update_open}
                onClose={() => set_contact_update_open(false)}
                onRefresh={onRefresh}
            />

            <CPM_CONTACT_DELETE
                id={contact.id}
                onOpen={var_contact_delete_open}
                onClose={() => set_contact_delete_open(false)}
                onRefresh={onRefresh}
            />

        </div>

    )
}